<template>

  <ControlloConsumi />
 
</template>

<script>
import ControlloConsumi from '../components/pratiche/ControlloConsumi.vue'

export default {
  components: {
    ControlloConsumi

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

